// Tiny safe markdown renderer used across the app
const SimpleMD = ({ text }) => {
  if (!text) return null;
  const lines = text.split("\n");
  return (
    <div className="ai-prose">
      {lines.map((line, i) => {
        const key = `${i}-${line.slice(0, 20)}`;
        if (/^###\s+/.test(line)) return <h3 key={key}>{line.replace(/^###\s+/, "")}</h3>;
        if (/^##\s+/.test(line)) return <h2 key={key}>{line.replace(/^##\s+/, "")}</h2>;
        if (/^#\s+/.test(line)) return <h1 key={key}>{line.replace(/^#\s+/, "")}</h1>;
        if (/^[-*]\s+/.test(line)) return <div key={key} className="pl-4">• {line.replace(/^[-*]\s+/, "")}</div>;
        if (line.trim() === "") return <div key={key} className="h-2" />;
        const parts = line.split(/(\*\*[^*]+\*\*)/g).map((part, j) =>
          /^\*\*[^*]+\*\*$/.test(part)
            ? <strong key={`${key}-b${j}-${part.slice(0, 8)}`}>{part.slice(2, -2)}</strong>
            : <span key={`${key}-s${j}-${part.slice(0, 8)}`}>{part}</span>
        );
        return <p key={key}>{parts}</p>;
      })}
    </div>
  );
};

export default SimpleMD;
